// Production
export const API_BASE = 'https://sotiem.vn';

// Development - dùng IP local nếu bị CORS
// export const API_BASE = 'http://localhost:5025';
